import React from 'react';
import { Routes, Route } from 'react-router-dom';

import HomeView from 'components/content/homeView/HomeView.js';
import ProjectView from './content/projectView/ProjectView.js';
import TransformView from './content/transformView/TransformView.js';
import HeaderRowSetView from './content/homeView/HeaderRowSetView.js';
import AddHelp from './content/help/AddHelp.js';
import TransformContextProvider from './content/transformView/TransformContext.js';
import ManualData from './content/homeView/ManualData.js';
// import Login from './Login'
const AppRouter = () => {
    return (
        <Routes>
            <Route path="/" exact element={<HomeView />} />
            <Route path="/project/" element={<ProjectView />} />
            <Route path="/project/:projectId" element={<ProjectView />} />

            <Route
                path="/transform/:projectId"
                element={
                    <TransformContextProvider>
                        <TransformView />
                    </TransformContextProvider>
                }
            />

            <Route path="/setheaderrow/:id" element={<HeaderRowSetView />} />
            <Route path="/manualdata/" element={<ManualData />} />
            {/* <Route path="/final-preview/:id" element={<FinalPreview />} /> */}
            <Route path="/add-help" element={<AddHelp />} />
            {/* <Route path="/login"  element={<Login/>} /> */}
        </Routes>
    );
};

export default AppRouter;
